import { useCallback, useEffect, useState } from 'react';

interface Props {
    onBlur: () => void;
    onFocus: () => void;
}

export default function useFocusGroup({onBlur, onFocus}: Props) {
    const [focusedCount, setFocusedCount] = useState(0);

    const handleChildFocus = useCallback(() => {
        setFocusedCount((c) => c + 1);
    }, []);

    const handleChildBlur = useCallback(() => {
        setTimeout(() => {
            setFocusedCount((c) => Math.max(0, c - 1));
        }, 0);
    }, []);

    useEffect(() => {
        (focusedCount ? onFocus : onBlur)();
    }, [focusedCount === 0]);

    return {handleChildBlur, handleChildFocus};
}
